import React, { useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import "./HallNoticeModal.css";

export type AgencySafetyModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

/** Nhắc xóa mã ẩn trước khi vào game — cùng khung bg-popup với THÔNG BÁO sảnh */
const AgencySafetyModal: React.FC<AgencySafetyModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    },
    [onClose]
  );

  useEffect(() => {
    if (!isOpen) return;
    document.addEventListener("keydown", onKeyDown);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prev;
    };
  }, [isOpen, onKeyDown]);

  if (!isOpen) return null;

  const modal = (
    <div
      className="hall-notice-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="agency-safety-title"
    >
      <button
        type="button"
        className="hall-notice-modal__backdrop"
        aria-label="Đóng"
        onClick={onClose}
      />
      <div className="hall-notice-modal__panel">
        <div className="hall-notice-modal__inner">
          <div
            className="hall-notice-modal__head"
            role="group"
            aria-labelledby="agency-safety-title"
          >
            <span className="hall-notice-modal__bell" aria-hidden>
              🔔
            </span>
            <h2 id="agency-safety-title" className="hall-notice-modal__title">
              THÔNG BÁO
            </h2>
            <span className="hall-notice-modal__bell" aria-hidden>
              🔔
            </span>
          </div>
          <p className="hall-notice-modal__body">
            Vui lòng xóa mã ẩn trước khi tham gia trò chơi để đảm bảo an toàn.
          </p>
          <button
            type="button"
            className="hall-notice-modal__btn"
            onClick={onConfirm}
          >
            ĐÃ HIỂU
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default AgencySafetyModal;
